import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import ConfirmModalDialog from '@/components/core/dialogs/ConfirmModalDialog.vue';

function ConfirmDialog({
	message,
	yesBtnText,
	noBtnText,
	showNoBtn = true,
	showYesBtn = true,
	modalWidth = '300',
}) {
	// let dummy=message;dummy=yesBtnText;dummy=noBtnText;JSON.stringify(dummy) //because eslint config

	let modal = document.createElement('div');
	document.body.appendChild(modal);
	return new Promise((resolve) => {
		let vModal = new Vue({
			vuetify,
			el: modal,
			components: {
				ConfirmModalDialog,
			},
			data: {
				showDialog: true,
				showYesBtn,
				showNoBtn,
				message,
				yesBtnText,
				noBtnText,
				modalWidth,
			},
			methods: {
				kill() {
					modal = vModal.$el;
					vModal.$destroy();
					if (modal.parentNode) {
						modal.parentNode.removeChild(modal);
					}
				},
				onConfirm() {
					this.showDialog = false;
					resolve(1);
					this.kill();
				},
				onCancel() {
					this.showDialog = false;
					resolve(0);
					this.kill();
				},
			},
			template: `<confirm-modal-dialog :showDialog="showDialog" :modalWidth="modalWidth":message="message" :yesBtnText="yesBtnText" :noBtnText="noBtnText" :showNoBtn="showNoBtn" :showYesBtn="showYesBtn" @confirm="onConfirm" @cancel="onCancel" />`,
		});
	});
}

export default ConfirmDialog;
